import bancoActions from "./bancoActions.js"
import cajaActions from "./cajaActions.js"
import clienteActions from "./clienteActions.js"
import codigoContableActions from "./codigoContableActions.js"
import componentsActions from "./componentsActions.js"
import sesionActions from "./sesionActions.js"
import filesActions from "./filesActions.js"
import proveedorActions from "./proveedorActions.js"
import profileActions from "./profileActions.js"
import settingsActions from "./settingsActions.js"
import gestionActions from "./gestionActions.js"
import inventoryActions from "./inventoryActions.js"
import personalActions from "./personalActions.js"
import subscriptionsActions from "./subscriptionsActions.js"
import compraVenta from "./compraVenta.js"
import hojasActions from "./hojasActions.js"
import serviceActions from "./serviceActions.js"

const actions = {
    ...bancoActions,
    ...cajaActions,
    ...clienteActions,
    ...codigoContableActions,
    ...componentsActions,
    ...filesActions,
    ...proveedorActions,
    ...sesionActions,
    ...profileActions,
    ...settingsActions,
    ...gestionActions,
    ...inventoryActions,
    ...personalActions,
    ...subscriptionsActions,
    ...compraVenta,
    ...hojasActions,
    ...serviceActions,
}

export default actions

